module.exports = __webpack_public_path__ + "resources/img/logo_toast_v2.87e79ca5a66bf11e4cec4bd5be805afb.svg";